import { useEffect, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { GiTyre } from 'react-icons/gi';
import { useDispatch, useSelector } from 'react-redux';
import PaginationCustom from '../components/Pagination';
import TableComponent from '../components/TableComponent';
import { fetchTyreData } from '../store/Slices/TyreSlice';

const Tyre = () => {
  const dispatch = useDispatch();
  const { data = [], loading = false, error = null, meta } = useSelector((state) => state.tyre);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const tyreColumnsLabels = [
    { value: "s_no", label: "S No." },
    { value: "system_sno", label: "System S.No." },
    { value: "uniqe_system_code", label: "Unique System Code" },
    { value: "category", label: "Category" },
    { value: "reg_no", label: "Reg No." },
    { value: "vehicle_brand", label: "Vehicle Brand" },
    { value: "vehicle_type", label: "Vehicle Type" },
    { value: "date", label: "Date" },
    { value: "changing_odometer", label: "Changing Odometer" },
    { value: "tyre_brand", label: "Tyre Brand" },
    { value: "location", label: "Location" },
    { value: "checked_by", label: "Checked By" },
    { value: "verified_by", label: "Verified By" },
    { value: "size", label: "Size" },
    { value: "tyre_type", label: "Tyre Type" },
    { value: "tyre_no", label: "Tyre No." },
    { value: "brand", label: "Brand" },
    { value: "tyre_side", label: "Tyre Side" },
    { value: "old_tyres_sr_no", label: "Old Tyres Sr No." },
    { value: "remarks_date", label: "Remarks Date" },
    { value: "remarks", label: "Remarks" }
  ];

  useEffect(() => {
    setCurrentPage(1);
  }, [limit])

  useEffect(() => {
    dispatch(fetchTyreData({
      page: currentPage,
      limit: limit
    }));
  }, [dispatch, currentPage, limit]);

  const refreshTyreData = () => {
    dispatch(fetchTyreData({
      page: currentPage,
      limit: limit
    }));
  };

  if (loading) {
    return <div className='loading_spinner'><Spinner animation="grow" /></div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  const csvType = {
    value: "tyres",
    label: "tyres"
  }


  
  return (
    <div className='table_main_wrapper'>
      <TableComponent
        heading="Tyres"
        icon={<GiTyre />}
        columns={tyreColumnsLabels}
        data={data}
        currentPage={currentPage}
        showAddBtn={true}
        className="maintenance_heading"
        csvType={csvType}
        onImportSuccess={refreshTyreData}
      />
      <PaginationCustom
        totalItems={meta?.totalItems}
        totalPages={meta?.totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        limit={limit}
        setLimit={setLimit}
      />
    </div>
  )
}

export default Tyre;
